import { render, staticRenderFns } from "./SujetUpdate.vue?vue&type=template&id=1f2aa870"
import script from "./SujetUpdate.vue?vue&type=script&lang=ts"
export * from "./SujetUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports